import React from 'react';
import { NotificationRecipient } from '../../types/product';

interface NotificationRecipientAvatarsProps {
  recipients: NotificationRecipient[];
  maxDisplay?: number;
}

/* 旧 styled-components 定義をクラス文字列定数として保持 */
const CONTAINER = 'flex items-center';
const AVATAR_WRAPPER = 'relative -ml-2 first:ml-0';
const AVATAR_COMMON =
  'w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-semibold ' +
  'border-2 border-white shadow-[0_1px_2px_rgba(0,0,0,0.1)]';
const AVATAR = `${AVATAR_COMMON} bg-[linear-gradient(135deg,#667eea_0%,#764ba2_100%)] text-white`;
const MORE_AVATAR = `${AVATAR_COMMON} bg-gray-200 text-gray-600`; /* #e5e7eb / #4b5563 */

const NotificationRecipientAvatars: React.FC<NotificationRecipientAvatarsProps> = ({
  recipients,
  maxDisplay = 5,
}) => {
  if (recipients.length === 0) {
    return null;
  }

  const displayedRecipients = recipients.slice(0, maxDisplay);
  const remainingCount = recipients.length - maxDisplay;

  const getInitials = (name: string): string => {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <div className={CONTAINER}>
      {displayedRecipients.map((recipient, index) => (
        <div
          key={recipient.id}
          className={AVATAR_WRAPPER}
          style={{ zIndex: displayedRecipients.length - index }}
          title={recipient.name}
        >
          <div className={AVATAR}>{getInitials(recipient.name)}</div>
        </div>
      ))}
      {remainingCount > 0 && (
        <div className={AVATAR_WRAPPER} style={{ zIndex: 0 }}>
          <div className={MORE_AVATAR}>+{remainingCount}</div>
        </div>
      )}
    </div>
  );
};

export default NotificationRecipientAvatars;
